import { AuxRadio, AuxSelect } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum } from "@blk/aladdin-web-components";
import { defaultTimePeriodDisplayValues, fromPeriodDropdownOptions } from "components/time-period/insSettingsTimePeriodHelper";
import { useWidgetCurrentTimePeriod, useWidgetCurrentFromPeriod } from "components/widgets/hooks/use-current-widget";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentStatusSelectedRadioTimePeriod, setCurrentStatusFromPeriod, updateDraftWorkspaceDateSettings } from "store/current-dashboard";
import { FromPeriods, TimePeriods } from "store/current-dashboard/types";
export const InsFromPeriod = (props) => {
    const isDashboard = props.isWidgetSettings === false;
    const dispatch = useDispatch();
    const draftDateSettings = useSelector((state) => state.currentDashboard?.draftWorkspaceSettings?.dateSettings);
    const workspaceDateSettings = useSelector((state) => state.currentDashboard?.workspaceSettings?.dateSettings);
    const widgetSelectedRadio = useWidgetCurrentTimePeriod(props.sectionId, props.widgetIds[0]);
    const widgetFromPeriod = useWidgetCurrentFromPeriod(props.sectionId, props.widgetIds[0]);
    const selectedRadio = isDashboard
        ? draftDateSettings?.selectedRadio ?? workspaceDateSettings?.selectedRadio ?? defaultTimePeriodDisplayValues.selectedRadio
        : widgetSelectedRadio;
    const fromPeriod = isDashboard
        ? draftDateSettings?.fromPeriod ?? workspaceDateSettings?.fromPeriod ?? defaultTimePeriodDisplayValues.fromPeriod
        : widgetFromPeriod;
    const isSelected = selectedRadio === TimePeriods.SpecifiedPeriodToAsOfDate;
    return (React.createElement("div", { className: "insRadioGroupDiv", key: TimePeriods.SpecifiedPeriodToAsOfDate },
        React.createElement(AuxRadio, { radioGroup: "timePeriod", eventData: TimePeriods.SpecifiedPeriodToAsOfDate, isChecked: isSelected, onRadioChanged: (event) => {
                const newRadio = event.detail.value.eventData;
                if (isDashboard) {
                    dispatch(updateDraftWorkspaceDateSettings({ fromPeriod: fromPeriod ?? FromPeriods.Inception, selectedRadio: newRadio }));
                }
                else {
                    dispatch(setCurrentStatusSelectedRadioTimePeriod({ props, selectedRadio: newRadio }));
                }
            } }),
        React.createElement(AuxSelect, { onSelectionChanged: (event) => {
                const newFromPeriod = event.detail.value.value;
                if (isDashboard) {
                    dispatch(updateDraftWorkspaceDateSettings({ fromPeriod: newFromPeriod }));
                }
                else {
                    dispatch(setCurrentStatusFromPeriod({ fromPeriod: newFromPeriod, props }));
                }
            }, hasInitialOptionPlaceholder: false, id: "fromPeriodSelect", className: "insRadioSelectWidth", isCompact: false, size: AuxButtonSizeEnum.SMALL, data: [{ values: fromPeriodDropdownOptions[0].values.map((option) => ({ ...option, isSelected: option.value === fromPeriod })) }], isDisabled: !isSelected }),
        React.createElement("span", { className: "radioGroupLabel" }, "\u00A0\u00A0to Date")));
};
